// Custom Video Enhancement for Safari Compatibility
(function() {
  'use strict';

  let videoPlayAttempts = new WeakMap();

  function ensureVideoPlays(video, attempt = 0) {
    if (!video) return;
    
    console.log('[Custom Video] Ensuring video plays, attempt:', attempt, 'readyState:', video.readyState);
    
    // Ensure critical Safari attributes
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('x5-playsinline', '');
    
    // Function to attempt playback
    function attemptPlay() {
      console.log('[Custom Video] Attempting to play, readyState:', video.readyState);
      
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(() => {
          console.log('[Custom Video] ✓ Playing successfully');
        }).catch(error => {
          console.warn('[Custom Video] ✗ Play prevented:', error.message);
          
          // Try up to 3 times
          if (attempt < 3) {
            setTimeout(() => {
              console.log('[Custom Video] Retrying playback...');
              video.muted = true;
              ensureVideoPlays(video, attempt + 1);
            }, 300 * (attempt + 1)); // Increasing delay
          }
        });
      }
    }
    
    // If video is already loaded enough, play immediately
    if (video.readyState >= 2) {
      console.log('[Custom Video] Video ready, playing now');
      attemptPlay();
    } else {
      console.log('[Custom Video] Waiting for video to load...');
      // Wait for video to load
      video.addEventListener('loadedmetadata', function() {
        console.log('[Custom Video] Metadata loaded');
        attemptPlay();
      }, { once: true });
      
      video.addEventListener('loadeddata', function() {
        console.log('[Custom Video] Data loaded');
        attemptPlay();
      }, { once: true });
      
      video.addEventListener('canplay', function() {
        console.log('[Custom Video] Can play');
        attemptPlay();
      }, { once: true });
      
      // Force load
      video.load();
    }
  }

  // Monitor for new videos being added to the DOM
  function observeCustomVideos() {
    console.log('[Custom Video] Setting up MutationObserver');
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if it's a video
            if (node.tagName === 'VIDEO') {
              const container = node.closest('[data-media-id*="custom-video"]');
              if (container) {
                console.log('[Custom Video] Video element added to DOM');
                ensureVideoPlays(node);
              }
            } else if (node.querySelectorAll) {
              // Check for videos within the added node
              const videos = node.querySelectorAll('video');
              videos.forEach(video => {
                const container = video.closest('[data-media-id*="custom-video"]');
                if (container) {
                  console.log('[Custom Video] Video found in subtree');
                  ensureVideoPlays(video);
                }
              });
            }
          }
        });
      });
    });
    
    // Observe the entire gallery viewer
    const viewer = document.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      console.log('[Custom Video] Observing gallery viewer');
      observer.observe(viewer, {
        childList: true,
        subtree: true
      });
    }
    
    // Also observe individual containers
    const containers = document.querySelectorAll('[data-media-id*="custom-video"]');
    console.log('[Custom Video] Found', containers.length, 'custom video containers');
    containers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
    
    return observer;
  }

  // Setup thumbnail videos to show first frame
  function setupThumbnailVideos() {
    const thumbnailVideos = document.querySelectorAll('[id*="Slide-Thumbnails"][id*="-custom-video"] video');
    console.log('[Custom Video] Setting up', thumbnailVideos.length, 'thumbnail videos');
    
    thumbnailVideos.forEach(video => {
      // Ensure video loads first frame
      video.addEventListener('loadeddata', function() {
        console.log('[Custom Video] Thumbnail video loaded, seeking to start');
        video.currentTime = 0.1; // Seek to 0.1 seconds to load first frame
      }, { once: true });
      
      video.addEventListener('seeked', function() {
        console.log('[Custom Video] Thumbnail video seeked to first frame');
      }, { once: true });
      
      // Force load
      if (video.readyState < 2) {
        video.load();
      } else if (video.currentTime === 0) {
        video.currentTime = 0.1;
      }
    });
  }

  // Initial setup
  function init() {
    console.log('[Custom Video] Script initialized');
    
    // Setup thumbnail videos
    setTimeout(() => {
      setupThumbnailVideos();
    }, 100);
    
    // Start observing for dynamically added videos
    observeCustomVideos();
    
    // Check for any existing videos in deferred media
    setTimeout(() => {
      const existingVideos = document.querySelectorAll('[data-media-id*="custom-video"] deferred-media video');
      console.log('[Custom Video] Found', existingVideos.length, 'existing deferred videos');
      existingVideos.forEach(video => {
        console.log('[Custom Video] Processing existing video');
        ensureVideoPlays(video);
      });
    }, 500);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
